export default __webpack_public_path__ + "static/media/img_fee_30.538ccf59.svg";